import axios from 'axios'
const state = () => ({
    menu: []
})

const getters = {
    menu(state) {
        return state.menu
    }
}

const mutations = {
    GET_MENU(state, payload){
        state.menu = payload
    },
}

const actions = {
    getMenu({commit}){
        axios.get(`https://api.geomalaka.uz/api/main/menu/`)
            .then((res)=>{
                commit("GET_MENU", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
